<mat-form-field [appearance]="options?.appearance? options.appearance : 'standard'">
    <mat-label>{{options.title}}<span class="asterisk"
            *ngIf="utils.isRequiredField(formControlSatelliteLock)">*</span></mat-label>
    <input (keyup)="changeValue()" matInput [matAutocomplete]="autocompleteSatelliteLocks"
        [formControl]="formControlSatelliteLock">
    <div matSuffix class="spinner-border text-info" role="status" *ngIf="loadingSatelliteLocks">
        <span class="sr-only">Loading...</span>
    </div>
    <mat-autocomplete #autocompleteSatelliteLocks="matAutocomplete" [displayWith]="displaySatelliteLockName"
        (optionSelected)="onSelectSatelliteLock($event)">
        <mat-option *ngFor="let satelliteLock of satelliteLocksFiltered" [value]="satelliteLock">
            <span *ngIf="satelliteLock.id || satelliteLock.consecutive">
                <span *ngIf="satelliteLock.id" class="mr-2"><strong>ID:</strong> {{satelliteLock.id}}</span>
                <span *ngIf="satelliteLock.consecutive"><strong>Consecutivo:</strong>
                    {{satelliteLock.consecutive}}</span>
            </span>
            <span *ngIf="!satelliteLock.id && !satelliteLock.consecutive">
                {{satelliteLock.consecutive}}
            </span>
        </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="formControlSatelliteLock.errors?.required">
        {{ utils.giveMessageError('MANDATORY_FIELD') }}
    </mat-error>
</mat-form-field>